import { connect } from 'react-redux'
import { compose, branch, renderNothing, setPropTypes } from 'recompose'
import PropTypes from 'prop-types'
import { selectListingsUriForZipcode } from 'src/store/selectors/customerProfile'

const ListingsContainer = compose(
  setPropTypes({
    zipcode: PropTypes.string.isRequired
  }),
  connect(
    (state, { zipcode }) => ({
      href: selectListingsUriForZipcode(zipcode)(state)
    }),
    () => ({})
  ),
  branch(({ href }) => !href, renderNothing)
)

export default ListingsContainer
